import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.66602 2.72157C1.66602 2.1386 2.1386 1.66602 2.72157 1.66602H17.2771C17.8601 1.66602 18.3327 2.1386 18.3327 2.72157V17.2771C18.3327 17.8601 17.8601 18.3327 17.2771 18.3327H2.72157C2.1386 18.3327 1.66602 17.8601 1.66602 17.2771V2.72157Z",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.71372 12.5961C7.14157 12.5961 6.62289 12.4732 6.15768 12.2272C5.69782 11.9759 5.33421 11.631 5.06685 11.1925C4.80484 10.7487 4.67383 10.2487 4.67383 9.6926C4.67383 9.13649 4.80484 8.6392 5.06685 8.20073C5.33421 7.75691 5.69782 7.41201 6.15768 7.16604C6.62289 6.91472 7.14425 6.78906 7.72175 6.78906C8.20834 6.78906 8.64681 6.87462 9.03716 7.04573C9.43286 7.21684 9.76438 7.46281 10.0317 7.78365L9.19758 8.55365C8.81793 8.11517 8.34737 7.89594 7.78591 7.89594C7.43834 7.89594 7.1282 7.97347 6.8555 8.12854C6.58279 8.27826 6.3689 8.48948 6.21383 8.76219C6.06411 9.0349 5.98924 9.34503 5.98924 9.6926C5.98924 10.0402 6.06411 10.3503 6.21383 10.623C6.3689 10.8957 6.58279 11.1096 6.8555 11.2647C7.1282 11.4144 7.43834 11.4893 7.78591 11.4893C8.34737 11.4893 8.81793 11.2674 9.19758 10.8235L10.0317 11.5935C9.76438 11.9197 9.43286 12.1684 9.03716 12.3395C8.64147 12.5106 8.20032 12.5961 7.71372 12.5961Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.0586 8.18469V12.4999H13.8715V11.9866C13.7058 12.1737 13.5079 12.3181 13.278 12.4197C13.0481 12.5159 12.7994 12.5641 12.5321 12.5641C11.9652 12.5641 11.5161 12.401 11.1846 12.0748C10.853 11.7486 10.6873 11.2647 10.6873 10.623V8.18469H11.9385V10.4385C11.9385 11.1337 12.2299 11.4813 12.8128 11.4813C13.1122 11.4813 13.3529 11.385 13.5347 11.1925C13.7165 10.9947 13.8074 10.7032 13.8074 10.3182V8.18469H15.0586Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }